// extracted by mini-css-extract-plugin
export var modal = "_ec-0";